module.exports = __webpack_public_path__ + "static/media/spreadsheet.eed50bd8.svg";